import Loadable from "components/Loadable";
import { FeatureRoutes } from "core/FeatureRoutes";
import MainLayout from "layouts/MainLayout";
import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router';

const Dashboard = Loadable(lazy(() => import('pages/mainlayout/dashboard')))
const ListUserManagement = Loadable(lazy(() => import('pages/mainlayout/userManagement/list')))
const FormUserManagement = Loadable(lazy(() => import('pages/mainlayout/userManagement/form')))
const ListCustomerManagement = Loadable(lazy(() => import('pages/mainlayout/customerManagement/list')))
const ListRoleManagement = Loadable(lazy(() => import('pages/mainlayout/roleManagement/list')))
const FormRoleManagement = Loadable(lazy(() => import('pages/mainlayout/roleManagement/form')))
const ListDaftarBankTujuan = Loadable(lazy(() => import('pages/mainlayout/daftarBankTujuan/list')))
const FormDaftarBankTujuan = Loadable(lazy(() => import('pages/mainlayout/daftarBankTujuan/form')))
const ListMessaging = Loadable(lazy(() => import('pages/mainlayout/messaging/list')))
const FormMessaging = Loadable(lazy(() => import('pages/mainlayout/messaging/form')))
const ListPengaturanFiturFungsi = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanFiturFungsi/list')))
const FormPengaturanFiturFungsi = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanFiturFungsi/form')))
const ListPengaturanInfografis = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanInfografis/list')))
const FormPengaturanInfografis = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanInfografis/form')))
const ListPengaturanCheckbox = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanCheckbox/list')))
const FormPengaturanCheckbox = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanCheckbox/form')))
const ListPengaturanKesepakatanNasabah = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanKesepakatanNasabah/list')))
const FormPengaturanKesepakatanNasabah = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanKesepakatanNasabah/form')))
const ListPengaturanPesanError = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanPesanError/list')))
const FormPengaturanPesanError = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanPesanError/form')))
const ListPengaturanFAQ = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanFAQ/list')))
const FormPengaturanFAQ = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanFAQ/form')))
const PengaturanTransaksi = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanTransaksi')))
const ListPengaturanBiayaTransaksi = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanTransaksi/biayaTransaksi/list')))
const FormPengaturanBiayaTransaksi = Loadable(lazy(() => import('pages/mainlayout/pengaturanParameter/pengaturanTransaksi/biayaTransaksi/form')))
const ListApproval = Loadable(lazy(() => import('pages/mainlayout/approval/list')))
const FormApproval = Loadable(lazy(() => import('pages/mainlayout/approval/form')))
const ListHistoryApproval = Loadable(lazy(() => import('pages/mainlayout/approval/list/history')))
const FormHistoryApproval = Loadable(lazy(() => import('pages/mainlayout/approval/form/history')))
const ListBlockId = Loadable(lazy(() => import('pages/mainlayout/block/block_customer/list')))
const ReportBlockId = Loadable(lazy(() => import('pages/mainlayout/block/block_customer/report')))
const FormBlockId = Loadable(lazy(() => import('pages/mainlayout/block/block_customer/form')))
const ListTutupFasilitas = Loadable(lazy(() => import('pages/mainlayout/block/tutup_fasilitas/list')))
const ListCustomerAgreementReport = Loadable(lazy(() => import('pages/mainlayout/report/customer_agreement/list')))
const ListTransactionReport = Loadable(lazy(() => import('pages/mainlayout/report/transaction/list')))
const ReportAuditTrail = Loadable(lazy(() => import('pages/mainlayout/report/auditTrail')))
const ListReportAuditTrailTipeTransaksi = Loadable(lazy(() => import('pages/mainlayout/report/auditTrail/tipeTransaksi/list')))
const FormReportAuditTrailTipeTransaksi = Loadable(lazy(() => import('pages/mainlayout/report/auditTrail/tipeTransaksi/form')))
const ListReportAuditTrailKelolaPengguna = Loadable(lazy(() => import('pages/mainlayout/report/auditTrail/kelolaPengguna/list')))
const FormReportAuditTrailKelolaPengguna = Loadable(lazy(() => import('pages/mainlayout/report/auditTrail/kelolaPengguna/form')))
const ListReportAuditTrailNasabah = Loadable(lazy(() => import('pages/mainlayout/report/auditTrail/nasabah/list')))
const FormReportAuditTrailNasabah = Loadable(lazy(() => import('pages/mainlayout/report/auditTrail/nasabah/form')))
const FormSetupBonusProdukWadiah = Loadable(lazy(() => import('pages/mainlayout/setupBonus/produkWadiah/form')))
const FormParameterGlobal = Loadable(lazy(() => import('pages/mainlayout/parameter/global/form')))
const FormParameterTemplate = Loadable(lazy(() => import('pages/mainlayout/parameter/template/form')))
const FormParameterInstance = Loadable(lazy(() => import('pages/mainlayout/parameter/instance/form')))
const ListParameterInstance = Loadable(lazy(() => import('pages/mainlayout/parameter/instance/list')))
const ListParameterGlobal = Loadable(lazy(() => import('pages/mainlayout/parameter/global/list')))
const FormRefundRTJH = Loadable(lazy(() => import('pages/mainlayout/refundRTJH/form')))
const FormCloseGoldFinAccount = Loadable(lazy(() => import('pages/mainlayout/goldFinancing/closeGoldFinAccount/form')))
const ListAuditTrailUserActivity = Loadable(lazy(() => import('pages/mainlayout/auditTrailUserActivity/list')))
const FormRevisedTransactionStatus = Loadable(lazy(() => import('pages/mainlayout/revisedTransactionStatus/form')))
const RevisedTransactionStatus = Loadable(lazy(() => import('pages/mainlayout/revisedTransactionStatus/list')))
const ListReportCustomerRTJH = Loadable(lazy(() => import('pages/mainlayout/reportCustomerRTJH/list')))
const ListDownloadGoldFin = Loadable(lazy(() => import('pages/mainlayout/goldFinancing/downloadGoldFin')))
const AuditListBeneficiaryBank = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/bankTujuan/list/audit')))
const AuditListPaymentInstitution = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/institusiPembayaran/list/audit')))
const AuditListHariLibur = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/hariLibur/list/audit')))
const ListTransactionType = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/tipeTransaksi/list')))
const FormTransactionType = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/tipeTransaksi/form')))
const ListPaymentInstitution = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/institusiPembayaran/list')))
const FormPaymentInstitution = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/institusiPembayaran/form')))
const ListHariLibur = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/hariLibur/list')))
const FormHariLibur = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/hariLibur/form')))
const FormBeneficiaryBank = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/bankTujuan/form')))
const ListBeneficiaryBank = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/bankTujuan/list')))
const InquiryBlokirSaldo = Loadable(lazy(() => import('pages/mainlayout/blokirSaldo/inquiry')))
const ListBlokirSaldo = Loadable(lazy(() => import('pages/mainlayout/blokirSaldo/list')))
const FormBlokirSaldo = Loadable(lazy(() => import('pages/mainlayout/blokirSaldo/form')))
const ListApprovalBlokirSaldo = Loadable(lazy(() => import('pages/mainlayout/approvalBlokirSaldo/list')))
const FormApprovalBlokirSaldo = Loadable(lazy(() => import('pages/mainlayout/approvalBlokirSaldo/form')))
const ListHistoryApprovalBlokirSaldo = Loadable(lazy(() => import('pages/mainlayout/report/blokirSaldo/list')))
const FormHistoryApprovalBlokirSaldo = Loadable(lazy(() => import('pages/mainlayout/report/blokirSaldo/form')))
const InquiryBlokirRekening = Loadable(lazy(() => import('pages/mainlayout/blokirRekening/event/inquiry')))
const ListBlokirRekening = Loadable(lazy(() => import('pages/mainlayout/blokirRekening/event/list')))
const FormBlokirRekening = Loadable(lazy(() => import('pages/mainlayout/blokirRekening/event/form')))
const ListApprovalBlokirRekening = Loadable(lazy(() => import('pages/mainlayout/approvalBlokirRekening/list')))
const ListHistoryApprovalBlokirRekening = Loadable(lazy(() => import('pages/mainlayout/report/blokirRekening/list')))
const FormApprovalBlokirRekening = Loadable(lazy(() => import('pages/mainlayout/approvalBlokirRekening/form')))
const FormHistoryApprovalBlokirRekening = Loadable(lazy(() => import('pages/mainlayout/report/blokirRekening/form')))
const ListApprovalBlokirID = Loadable(lazy(() => import('pages/mainlayout/approvalBlokirID/list')))
const FormApprovalBlokirID = Loadable(lazy(() => import('pages/mainlayout/approvalBlokirID/form')))
const ListDeviceManagement = Loadable(lazy(() => import('pages/mainlayout/deviceManagement/list')))
const ListApprovalDeviceManagement = Loadable(lazy(() => import('pages/mainlayout/approvalDeviceManagement/list')))
const FormApprovalDeviceManagement = Loadable(lazy(() => import('pages/mainlayout/approvalDeviceManagement/form')))
const ListReportDeviceManagement = Loadable(lazy(() => import('pages/mainlayout/report/deviceManagement/list')))
const FormReportDeviceManagement = Loadable(lazy(() => import('pages/mainlayout/report/deviceManagement/form')))
const ListInfoManagement = Loadable(lazy(() => import('pages/mainlayout/inboxManagement/infoManagement/list')))
const FormInfoManagement = Loadable(lazy(() => import('pages/mainlayout/inboxManagement/infoManagement/form')))
const ListApprovalInfoManagement = Loadable(lazy(() => import('pages/mainlayout/approvalInfoManagement/list')))
const FormApprovalInfoManagement = Loadable(lazy(() => import('pages/mainlayout/approvalInfoManagement/form')))
const ListReportInfoManagement = Loadable(lazy(() => import('pages/mainlayout/report/infoManagement/list')))
const FormReportInfoManagement = Loadable(lazy(() => import('pages/mainlayout/report/infoManagement/form')))
const ListPromoManagement = Loadable(lazy(() => import('pages/mainlayout/inboxManagement/promoManagement/list')))
const FormPromoManagement = Loadable(lazy(() => import('pages/mainlayout/inboxManagement/promoManagement/form')))
const ListApprovalPromoManagement = Loadable(lazy(() => import('pages/mainlayout/approvalPromoManagement/list')))
const FormApprovalPromoManagement = Loadable(lazy(() => import('pages/mainlayout/approvalPromoManagement/form')))
const ListReportPromoManagement = Loadable(lazy(() => import('pages/mainlayout/report/promoManagement/list')))
const ListReportMultiDevice = Loadable(lazy(() => import('pages/mainlayout/report/multiDevice/list')))
const FormReportPromoManagement = Loadable(lazy(() => import('pages/mainlayout/report/promoManagement/form')))
const ListBaznas = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/baznas/list')))
const FormBaznas = Loadable(lazy(() => import('pages/mainlayout/parameterTransaction/baznas/form')))
const ListApprovalBankTujuan = Loadable(lazy(() => import('pages/mainlayout/approvalBankTujuan/list')))
const FormApprovalBankTujuan = Loadable(lazy(() => import('pages/mainlayout/approvalBankTujuan/form')))
const ListReportBankTujuan = Loadable(lazy(() => import('pages/mainlayout/report/bankTujuan/list')))
const FormReportBankTujuan = Loadable(lazy(() => import('pages/mainlayout/report/bankTujuan/form')))
const ListReportAktifasiSakuValas = Loadable(lazy(() => import('pages/mainlayout/report/aktivasiSakuValas/list')))
const ListReportOutstandingSakuValas = Loadable(lazy(() => import('pages/mainlayout/report/outstandingValas/list')))
const ListReportMutasiSakuValas = Loadable(lazy(() => import('pages/mainlayout/report/mutasiValas/list')))

const ListKelolaLoginScreen = Loadable(lazy(() => import('pages/mainlayout/loginManagement/list')))
const FormKelolaLoginScreen = Loadable(lazy(() => import('pages/mainlayout/loginManagement/form')))

// Don't forget to add path on file pathMenus.js for path validation
const MainRoutes: RouteObject = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: 'dashboard',
            element: <Dashboard />
        },
        {
            path: 'messaging',
            element: <FormMessaging />,
            children: [
                {
                    path: ':id',
                    element: <FormMessaging />,
                }
            ]
        },
        {
            path: 'messaging/history',
            element: <ListMessaging />,
        },
        {
            path: 'list',
            children: [

                {
                    path: 'kelola-pengguna',
                    element: <ListUserManagement />
                },
                {
                    path: 'kelola-nasabah/blokir-id',
                    element: <ListBlockId />,
                },
                {
                    path: 'kelola-nasabah/blokir-id/form',
                    element: <FormBlockId />,
                },
                {
                    path: 'kelola-nasabah/blokir-saldo',
                    element: <InquiryBlokirSaldo />
                },
                {
                    path: 'kelola-nasabah/blokir-saldo',
                    element: <ListBlokirSaldo />,
                    children: [
                        {
                            path: ':id',
                            element: <FormBlokirSaldo />,
                        }
                    ]
                },
                {
                    path: 'kelola-nasabah/blokir-rekening',
                    element: <InquiryBlokirRekening />
                },
                {
                    path: 'kelola-nasabah/blokir-rekening',
                    element: <ListBlokirRekening />,
                    children: [
                        {
                            path: ':id',
                            element: <FormBlokirRekening />,
                        }
                    ]
                },
                {
                    path: 'kelola-hak-akses',
                    element: <ListRoleManagement />
                },
                {
                    path: 'daftar-bank-tujuan',
                    element: <ListDaftarBankTujuan />
                },
                {
                    path: 'persetujuan',
                    element: <ListApproval />
                },
                {
                    path: 'persetujuan/history',
                    element: <ListHistoryApproval />
                },
                {
                    path: 'persetujuan/blokir-rekening',
                    element: <ListApprovalBlokirRekening />
                },
                {
                    path: 'persetujuan/blokir-saldo',
                    element: <ListApprovalBlokirSaldo />
                },
                {
                    path: 'persetujuan/blokir-id',
                    element: <ListApprovalBlokirID />
                },
                // {
                //     path: 'persetujuan/blokir-rekening/history',
                //     element: <ListHistoryApprovalBlokirRekening />
                // },
                {
                    path: 'laporan/audit-trail/tipe-transaksi',
                    element: <ListReportAuditTrailTipeTransaksi />
                },
                {
                    path: 'laporan/audit-trail/kelola-pengguna',
                    element: <ListReportAuditTrailKelolaPengguna />
                },
                {
                    path: 'laporan/audit-trail/nasabah',
                    element: <ListReportAuditTrailNasabah />
                },
                {
                    path: 'refund-rtjh',
                    element: <FormRefundRTJH />
                },
                {
                    path: 'audit-trail-user-activity',
                    element: <ListAuditTrailUserActivity />
                },
                {
                    path: 'report-customer-rtjh',
                    element: <ListReportCustomerRTJH />
                },
                {
                    path: 'blokir/blokir-id',
                    element: <ListBlockId />
                },
                {
                    path: 'blokir/tutup-fasilitas',
                    element: <ListTutupFasilitas />
                },
                {
                    path: 'kelola-nasabah/kelola-device',
                    element: <ListDeviceManagement />
                },
                {
                    path: 'persetujuan/kelola-device',
                    element: <ListApprovalDeviceManagement />
                },
                {
                    path: 'persetujuan/kelola-info',
                    element: <ListApprovalInfoManagement />
                },
                {
                    path: 'persetujuan/kelola-promo',
                    element: <ListApprovalPromoManagement />
                },
                {
                    path: 'persetujuan/bank-tujuan',
                    element: <ListApprovalBankTujuan />
                },

                {
                    path: "kelola-login-screen",
                    element: <ListKelolaLoginScreen />,
                },

            ]
        },
        {
            path: 'form',
            children: [

                {
                    path: 'kelola-pengguna',
                    element: <FormUserManagement />,
                    children: [
                        {
                            path: ':id',
                            element: <FormUserManagement />,
                        }
                    ]
                },
                {
                    path: 'kelola-hak-akses',
                    element: <FormRoleManagement />,
                    children: [
                        {
                            path: ':id',
                            element: <FormRoleManagement />,
                        }
                    ]
                },
                {
                    path: 'daftar-bank-tujuan',
                    element: <FormDaftarBankTujuan />,
                    children: [
                        {
                            path: ':id',
                            element: <FormDaftarBankTujuan />,
                        }
                    ]
                },
                {
                    path: 'fitur-fungsi',
                    element: <FormPengaturanFiturFungsi />,
                    children: [
                        {
                            path: ':id',
                            element: <FormPengaturanFiturFungsi />,
                        }
                    ]
                },
                {
                    path: 'infografis',
                    element: <FormPengaturanInfografis />,
                    children: [
                        {
                            path: ':id',
                            element: <FormPengaturanInfografis />,
                        }
                    ]
                },
                {
                    path: 'checkbox',
                    element: <FormPengaturanCheckbox />,
                    children: [
                        {
                            path: ':id',
                            element: <FormPengaturanCheckbox />,
                        }
                    ]
                },
                {
                    path: 'kesepakatan-nasabah',
                    element: <FormPengaturanKesepakatanNasabah />,
                    children: [
                        {
                            path: ':id',
                            element: <FormPengaturanKesepakatanNasabah />,
                        }
                    ]
                },
                {
                    path: 'pesan-error',
                    element: <FormPengaturanPesanError />,
                    children: [
                        {
                            path: ':id',
                            element: <FormPengaturanPesanError />,
                        }
                    ]
                },
                {
                    path: 'faq',
                    element: <FormPengaturanFAQ />,
                    children: [
                        {
                            path: ':id',
                            element: <FormPengaturanFAQ />,
                        }
                    ]
                },
                {
                    path: 'biaya-transaksi',
                    element: <FormPengaturanBiayaTransaksi />,
                    children: [
                        {
                            path: ':id',
                            element: <FormPengaturanBiayaTransaksi />,
                        }
                    ]
                },
                {
                    path: 'persetujuan',
                    element: <FormApproval />,
                    children: [
                        {
                            path: ':id',
                            element: <FormApproval />,
                        }
                    ]
                },
                {
                    path: 'persetujuan/history',
                    element: <FormHistoryApproval />,
                    children: [
                        {
                            path: ':id',
                            element: <FormHistoryApproval />,
                        }
                    ]
                },
                {
                    path: 'persetujuan/blokir-rekening',
                    element: <FormApprovalBlokirRekening />,
                    children: [
                        {
                            path: ':id',
                            element: <FormApprovalBlokirRekening />,
                        }
                    ]
                },
                {
                    path: 'persetujuan/blokir-id',
                    element: <FormApprovalBlokirID />,
                    children: [
                        {
                            path: ':id',
                            element: <FormApprovalBlokirID />,
                        }
                    ]
                },
                {
                    path: 'laporan/blokir-rekening',
                    element: <FormHistoryApprovalBlokirRekening />,
                    children: [
                        {
                            path: ':id',
                            element: <FormHistoryApprovalBlokirRekening />,
                        }
                    ]
                },
                {
                    path: 'persetujuan/blokir-saldo',
                    element: <FormApprovalBlokirSaldo />,
                    children: [
                        {
                            path: ':id',
                            element: <FormApprovalBlokirSaldo />,
                        }
                    ]
                },
                {
                    path: 'laporan/blokir-saldo',
                    element: <FormHistoryApprovalBlokirSaldo />,
                    children: [
                        {
                            path: ':id',
                            element: <FormHistoryApprovalBlokirSaldo />,
                        }
                    ]
                },
                {
                    path: 'laporan/audit-trail/tipe-transaksi',
                    element: <FormReportAuditTrailTipeTransaksi />,
                    children: [
                        {
                            path: ':id',
                            element: <FormReportAuditTrailTipeTransaksi />,
                        }
                    ]
                },
                {
                    path: 'laporan/audit-trail/kelola-pengguna',
                    element: <FormReportAuditTrailKelolaPengguna />,
                    children: [
                        {
                            path: ':id',
                            element: <FormReportAuditTrailKelolaPengguna />,
                        }
                    ]
                },
                {
                    path: 'laporan/audit-trail/nasabah',
                    element: <FormReportAuditTrailNasabah />,
                    children: [
                        {
                            path: ':id',
                            element: <FormReportAuditTrailNasabah />,
                        }
                    ]
                },
                {
                    path: 'parameter/instance',
                    element: <FormParameterInstance />,
                    children: [
                        {
                            path: ':id',
                            element: <FormParameterInstance />,
                        }
                    ]
                },
                {
                    path: 'parameter/global',
                    element: <FormParameterGlobal />,
                    children: [
                        {
                            path: ':id',
                            element: <FormParameterGlobal />,
                        },
                    ]
                },
                {
                    path: 'parameter-transaksi/hari-libur',
                    element: <FormHariLibur />,
                    children: [
                        {
                            path: ':type/:id',
                            element: <FormHariLibur />,
                        }
                    ]
                },
                {
                    path: 'parameter-transaksi/bank-tujuan',
                    element: <FormBeneficiaryBank />,
                    children: [
                        {
                            path: ':type/:id',
                            element: <FormBeneficiaryBank />,
                        }
                    ]
                },
                {
                    path: 'parameter-transaksi/tipe-transaksi',
                    element: <FormTransactionType />,
                    children: [
                        {
                            path: ':id',
                            element: <FormTransactionType />,
                        }
                    ]
                },
                {
                    path: 'parameter-transaksi/institusi-pembayaran',
                    element: <FormPaymentInstitution />,
                    children: [
                        {
                            path: ':type/:id',
                            element: <FormPaymentInstitution />,
                        }
                    ]
                },
                {
                    path: 'parameter-transaksi/zakat-donasi',
                    element: <FormBaznas />,
                    children: [
                        {
                            path: ':id',
                            element: <FormBaznas />,
                        }
                    ]
                },
                {
                    path: 'blokir/blokir-id',
                    element: <FormBlockId />,
                },
                {
                    path: 'kelola-nasabah/blokir-saldo',
                    element: <FormBlokirSaldo />,
                    children: [
                        {
                            path: ':id',
                            element: <FormBlokirSaldo />,
                        }
                    ]
                },
                {
                    path: 'kelola-nasabah/blokir-rekening',
                    element: <FormBlokirRekening />,
                    children: [
                        {
                            path: ':id',
                            element: <FormBlokirRekening />,
                        }
                    ]
                },
                {
                    path: 'persetujuan/kelola-device',
                    element: <FormApprovalDeviceManagement />,
                    children: [
                        {
                            path: ':id',
                            element: <FormApprovalDeviceManagement />,
                        }
                    ]
                },
                {
                    path: 'laporan/kelola-device',
                    element: <FormReportDeviceManagement />,
                    children: [
                        {
                            path: ':id',
                            element: <FormReportDeviceManagement />,
                        }
                    ]
                },
                {
                    path: 'kelola-inbox/info',
                    element: <FormInfoManagement />,
                    children: [
                        {
                            path: ':id',
                            element: <FormInfoManagement />,
                        }
                    ]
                },
                {
                    path: 'persetujuan/kelola-info',
                    element: <FormApprovalInfoManagement />,
                    children: [
                        {
                            path: ':id',
                            element: <FormApprovalInfoManagement />,
                        }
                    ]
                },
                {
                    path: 'laporan/kelola-info',
                    element: <FormReportInfoManagement />,
                    children: [
                        {
                            path: ':id',
                            element: <FormReportInfoManagement />,
                        }
                    ]
                },
                {
                    path: 'kelola-inbox/promo',
                    element: <FormPromoManagement />,
                    children: [
                        {
                            path: ':id',
                            element: <FormPromoManagement />,
                        }
                    ]
                },
                {
                    path: 'persetujuan/kelola-promo',
                    element: <FormApprovalPromoManagement />,
                    children: [
                        {
                            path: ':id',
                            element: <FormApprovalPromoManagement />,
                        }
                    ]
                },
                {
                    path: 'laporan/kelola-promo',
                    element: <FormReportPromoManagement />,
                    children: [
                        {
                            path: ':id',
                            element: <FormReportPromoManagement />,
                        }
                    ]
                },
                {
                    path: 'persetujuan/bank-tujuan',
                    element: <FormApprovalBankTujuan />,
                    children: [
                        {
                            path: ':id',
                            element: <FormApprovalBankTujuan />,
                        }
                    ]
                },
                {
                    path: 'laporan/parameter-bank-tujuan',
                    element: <FormReportBankTujuan />,
                    children: [
                        {
                            path: ':id',
                            element: <FormReportBankTujuan />,
                        }
                    ]
                },

                {
                    path: "kelola-login-screen",
                    element: <FormKelolaLoginScreen />,
                    children: [
                        {
                            path: ':id',
                            element: <FormKelolaLoginScreen />,
                        }
                    ]
                },

            ]
        },
        // {
        //     path: 'pengaturan-parameter',
        //     children: [
        //         {
        //             path: 'fungsi-fitur',
        //             element: <ListPengaturanFiturFungsi />
        //         },
        //         {
        //             path: 'infografis',
        //             element: <ListPengaturanInfografis />
        //         },
        //         {
        //             path: 'checkbox',
        //             element: <ListPengaturanCheckbox />
        //         },
        //         {
        //             path: 'kesepakatan-nasabah',
        //             element: <ListPengaturanKesepakatanNasabah />
        //         },
        //         {
        //             path: 'pesan-error',
        //             element: <ListPengaturanPesanError />
        //         },
        //         {
        //             path: 'transaksi',
        //             element: <PengaturanTransaksi />
        //         },
        //         {
        //             path: 'faq',
        //             element: <ListPengaturanFAQ />
        //         }
        //     ]
        // },
        // {
        //     path: 'pengaturan-parameter/transaksi',
        //     children: [
        //         {
        //             path: 'limit-transaksi',
        //             element: <ListPengaturanFiturFungsi />
        //         },
        //         {
        //             path: 'biaya-transaksi',
        //             element: <ListPengaturanBiayaTransaksi />
        //         },
        //         {
        //             path: 'kategori-transaksi',
        //             element: <ListPengaturanCheckbox />
        //         },
        //     ]
        // },
        {
            path: 'laporan',
            children: [
                {
                    path: 'kesepakatan-nasabah',
                    element: <ListCustomerAgreementReport />
                },
                {
                    path: 'audit-trail',
                    element: <ReportAuditTrail />
                },
                {
                    path: 'transaksi',
                    element: <ListTransactionReport />
                },
                {
                    path: 'blokir-rekening',
                    element: <ListHistoryApprovalBlokirRekening />
                },
                {
                    path: 'blokir-saldo',
                    element: <ListHistoryApprovalBlokirSaldo />
                },
                {
                    path: 'blokir-id',
                    element: <ReportBlockId />,
                },
                {
                    path: 'kelola-device',
                    element: <ListReportDeviceManagement />,
                },
                {
                    path: 'kelola-info',
                    element: <ListReportInfoManagement />,
                },
                {
                    path: 'kelola-promo',
                    element: <ListReportPromoManagement />,
                },
                {
                    path: 'multidevice',
                    element: <ListReportMultiDevice />,
                },
                {
                    path: 'parameter-bank-tujuan',
                    element: <ListReportBankTujuan />,
                },
                {
                    path: 'aktivasi-saku-valas',
                    element: <ListReportAktifasiSakuValas />,
                },
                {
                    path: 'outstanding-valas',
                    element: <ListReportOutstandingSakuValas />,
                },
                {
                    path: 'mutasi-valas',
                    element: <ListReportMutasiSakuValas />,
                },

            ]
        },
        {
            path: 'setup-bonus',
            children: [
                {
                    path: 'product-wadiah',
                    element: <FormSetupBonusProdukWadiah />
                },
            ]
        },
        {
            path: 'parameter',
            children: [
                {
                    path: 'global',
                    element: <ListParameterGlobal />,
                },
                {
                    path: 'template',
                    element: <FormParameterTemplate />
                },
                {
                    path: 'instance',
                    element: <ListParameterInstance />
                },
            ]
        },
        {
            path: 'kelola-inbox',
            children: [
                {
                    path: 'info',
                    element: <ListInfoManagement />,
                },
                {
                    path: 'promo',
                    element: <ListPromoManagement />
                },
            ]
        },
        {
            path: 'parameter-transaksi',
            children: [
                {
                    path: 'institusi-pembayaran',
                    element: <ListPaymentInstitution />,
                },
                {
                    path: 'hari-libur',
                    element: <ListHariLibur />
                },
                {
                    path: 'tipe-transaksi',
                    element: <ListTransactionType />
                },
                {
                    path: 'bank-tujuan',
                    element: <ListBeneficiaryBank />
                },
                {
                    path: 'zakat-donasi',
                    element: <ListBaznas />,
                },
            ]
        },
        {
            path: 'gold-financing',
            children: [
                {
                    path: 'close-gold-fin-account',
                    element: <FormCloseGoldFinAccount />,
                },
                {
                    path: 'download',
                    element: <ListDownloadGoldFin />,
                },
            ]
        },
        {
            path: 'revised-transaction-status',
            children: [
                {
                    path: 'input',
                    element: <RevisedTransactionStatus />,
                },
                {
                    path: 'form/:id',
                    element: <FormRevisedTransactionStatus />,
                },
            ]
        },
        {
            path: 'audit',
            children: [
                {
                    path: 'parameter-transaksi/bank-tujuan',
                    element: <AuditListBeneficiaryBank />,
                    children: [
                        {
                            path: ':id',
                            element: <AuditListBeneficiaryBank />,
                        },
                    ]
                },
                {
                    path: 'parameter-transaksi/institusi-pembayaran',
                    element: <AuditListPaymentInstitution />,
                    children: [
                        {
                            path: ':id',
                            element: <AuditListPaymentInstitution />,
                        },
                    ]
                },
                {
                    path: 'parameter-transaksi/hari-libur',
                    element: <AuditListHariLibur />,
                    children: [
                        {
                            path: ':id',
                            element: <AuditListHariLibur />,
                        },
                    ]
                },
            ]
        },
        // {
        //     path: 'blokir',
        //     children: [
        //         {
        //             path: 'blokir-id',
        //             element: <ListBlockId />
        //         },
        //         {
        //             path: 'blokir-id/report',
        //             element: <ReportBlockId />,
        //         },
        //         {
        //             path: 'tutup-fasilitas',
        //             element: <ListTutupFasilitas />
        //         },
        //     ]
        // },

        // NOTE: V2 Routes, do not touch
        ...FeatureRoutes
    ],
};

export default MainRoutes;
